import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const LocalDraftModal = ({ show, onHide, onConfirm, isChecking = false, showUpdateOption = true }) => {
  // If showUpdateOption is false, default to "new", otherwise default to "update"
  const [draftChoice, setDraftChoice] = useState(showUpdateOption ? "update" : "new");
  const [newDraftTitle, setNewDraftTitle] = useState("");
  const [error, setError] = useState("");

  // Reset draftChoice when modal opens based on showUpdateOption
  useEffect(() => {
    if (show) {
      setDraftChoice(showUpdateOption ? "update" : "new");
      setNewDraftTitle("");
      setError("");
    }
  }, [show, showUpdateOption]);

  const handleSubmit = () => {
    if (draftChoice === "new" && !newDraftTitle.trim()) {
      setError("Please enter a title for the new draft");
      return;
    }
    
    setError("");
    onConfirm(draftChoice, newDraftTitle.trim());
  };

  const handleClose = () => {
    setDraftChoice(showUpdateOption ? "update" : "new");
    setNewDraftTitle("");
    setError("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Save as Draft</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <div className="mb-3">
          <p className="text-muted mb-3">
            {showUpdateOption 
              ? "Choose how you want to save this draft:"
              : "Enter a name for your new draft:"}
          </p>
        </div>
        
        <Form>
          {showUpdateOption && (
            <Form.Group className="mb-3">
              <Form.Check
                type="radio"
                id="update-existing"
                name="draftChoice"
                label="Update existing draft"
                checked={draftChoice === "update"}
                onChange={() => setDraftChoice("update")}
                className="mb-2"
              />
              <Form.Check
                type="radio"
                id="create-new"
                name="draftChoice"
                label="Create new draft"
                checked={draftChoice === "new"}
                onChange={() => setDraftChoice("new")}
                className="mb-3"
              />
            </Form.Group>
          )}
          
          {(draftChoice === "new" || !showUpdateOption) && (
            <Form.Group className="mb-3">
              <Form.Label>Draft Title <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={newDraftTitle}
                onChange={(e) => {
                  setNewDraftTitle(e.target.value);
                  setError(""); // Clear error when user starts typing
                }}
                placeholder="Enter draft title"
                required
                autoFocus
                disabled={isChecking}
              />
              {error && (
                <Alert variant="danger" className="mt-2 mb-0">
                  <small>{error}</small>
                </Alert>
              )}
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isChecking}>
          Cancel
        </Button>
        <Button 
          variant="dark" 
          onClick={handleSubmit}
          disabled={isChecking || (draftChoice === "new" && !newDraftTitle.trim())}
        >
          {isChecking ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            draftChoice === "update" ? "Update Draft" : "Create New Draft"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocalDraftModal;
